import React from 'react';
import PropTypes from 'prop-types';

import InfoSelectField from 'ntnu-react/material/InfoSelectField';
import MenuItem from 'material-ui/MenuItem';

import info from '../constants/infotexts.json';
import choices from '../constants/choices.json';

const { Scope } = choices;

const styles = {
    flex: {
        flex: 1,
        marginBottom: '2em',
    },
};

class ScopeTab extends React.Component {
    shouldComponentUpdate(nextProps) {
        const old = this.props.data;
        const next = nextProps.data;

        return old.Scope1 !== next.Scope1
        || old.Scope2 !== next.Scope2
        || old.Scope3 !== next.Scope3
        || old.Scope4 !== next.Scope4;
    }

    handleSelectChange = (field) => {
        return (e, index, value) => {
            this.props.fieldChange(field, value, true);
        };
    }

    render() {
        const { data } = this.props;
        return (
            <section style={{
                display: 'flex',
                flexDirection: 'column',
            }}>
                <InfoSelectField
                    floatingLabelText="Kostnad gjennomføring (i tusen)"
                    infoText={info.scope.Scope1}
                    value={data.Scope1}
                    onChange={this.handleSelectChange('Scope1')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Scope.Scope1.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Scope1 === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoSelectField
                    floatingLabelText="Reduserte løpende kostnader"
                    infoText={info.scope.Scope2}
                    value={data.Scope2}
                    onChange={this.handleSelectChange('Scope2')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Scope.Scope2.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Scope2 === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoSelectField
                    floatingLabelText="Varighet i tid. (angitt i måneder)"
                    infoText={info.scope.Scope3}
                    value={data.Scope3}
                    onChange={this.handleSelectChange('Scope3')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Scope.Scope3.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Scope3 === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoSelectField
                    floatingLabelText="Kompetansebehovet endres"
                    infoText={info.scope.Scope4}
                    value={data.Scope4}
                    onChange={this.handleSelectChange('Scope4')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Scope.Scope4.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Scope4 === item.key}
                        />
                    ))}
                </InfoSelectField>
            </section>
        );
    }
}

ScopeTab.propTypes = {
    data: PropTypes.object.isRequired,
    fieldChange: PropTypes.func.isRequired,
    style: PropTypes.object,
    disabled: PropTypes.bool,
};

export default ScopeTab;



// WEBPACK FOOTER //
// ./src/components/ScopeTab.js